export const LOBBY_PRIMARY_ACTION_TYPES = {
  ACTIVE_GAME: 'ACTIVE_GAME',
  CUSTOM_URL: 'CUSTOM_URL',
  PROMOTION: 'PROMOTION',
  REFER_A_FRIEND: 'REFER_A_FRIEND',
  SMARTICO_MINI_GAMES: 'SMARTICO_MINI_GAMES',
  SMARTICO_MISSIONS: 'SMARTICO_MISSIONS',
  SMARTICO_STORE: 'SMARTICO_STORE',
  TOURNAMENT: 'TOURNAMENT',
  URL: 'URL',
};

export const LOBBY_PRIMARY_BREAKPOINTS = {
  1: {
    slidesPerView: 2,
  },
  280: {
    slidesPerView: 3,
  },
  390: {
    slidesPerView: 4,
  },
  520: {
    slidesPerView: 5,
  },
  660: {
    slidesPerView: 6,
  },
  790: {
    slidesPerView: 7,
  },
  920: {
    slidesPerView: 8,
  },
  1050: {
    slidesPerView: 9,
  },
  1180: {
    slidesPerView: 10,
  },
  1320: {
    slidesPerView: 11,
  },
  1450: {
    slidesPerView: 12,
  },
};
